import { InputAdornment, TextField } from "@mui/material";
import axios from "axios";
import { useState } from "react";
import { alert } from "src/services/alert";
import { asyncRequest } from "src/services/network";
import FormDialog from "src/components/common/FormDialog";
import FormItem from "src/components/form-item/FormItem";

const ChangeSupplierPwdDialog = ({ row, open, onClose }) => {
  const [form, setForm] = useState({
    passwordNew: "",
    passwordNew2: "",
  });

  function handleIptChange(ki, val) {
    // console.log(ki, val);
    setForm({
      ...form,
      [ki]: val,
    });
  }

  async function handleDialogConfirm() {
    const { passwordNew, passwordNew2 } = form;
    if (passwordNew !== passwordNew2) return alert("两次密码不一致");

    const { msg } = await asyncRequest({
      path: "/supplier/resetPwd",
      data: {
        sid: row.id,
        password: passwordNew,
      },
    });

    setForm({
      passwordNew: "",
      passwordNew2: "",
    });
    alert(msg, "success");
    onClose();
  }

  return (
    <FormDialog title="修改密码" open={open} onClose={onClose} onConfirm={handleDialogConfirm}>
      <FormItem title="管理员">
        <TextField fullWidth disabled value={row.realname || row.username || row.name} size="small" />
      </FormItem>

      <FormItem title="新密码">
        <TextField fullWidth type="password" placeholder="新密码" autoComplete="off" id="passwordNew" value={form.passwordNew} size="small" onChange={(e) => handleIptChange("passwordNew", e.target.value)} />
      </FormItem>

      <FormItem title="确认密码">
        <TextField fullWidth type="password" placeholder="确认密码" autoComplete="off" id="passwordNew2" value={form.passwordNew2} size="small" onChange={(e) => handleIptChange("passwordNew2", e.target.value)} />
      </FormItem>
    </FormDialog>
  );
};

export default ChangeSupplierPwdDialog;
